import { FC } from 'react';
import {Box, styled, Typography, TypographyProps } from '@mui/material';
import { ComponentsCategory } from 'types/components';
import { MainTitle } from 'components/common/Title';

const Text = styled(Typography)(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '600',
    // fontFamily: 'Open Sans',
    color: theme.palette.text.primary,
    fontSize: '20px',
    lineHeight: '26px',
    maxWidth: '600px',
    lineWidth: '500px',
    textWrap: 'wrap',
    textAlign: 'left',
    whiteSpace: "pre-line",
    // textWrap: 'wrap',
    wordBreak: 'break-word',
    // overflow: 'break-word',
    nowrap: false,
    // textOverflow: "ellipsis",
    // overflowWrap: 'break-word',
    // wordBreak: "break-word",
    [theme.breakpoints.up('xs')]: {
      marginBottom: '5px',
      fontSize: '16px',
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: '18px',
    },
  }));

interface Props {
    children?: React.ReactNode,
    data: any
}

const ImageTextBox: FC<Props> = ({ children, data, ...props }) => {
    return (
        <Box mt={4} gap='5px' display='flex' flexDirection='column' sx={{padding: '10px', width: '100%'}}>
        <MainTitle textAlign='left' padding='0' fontSizeXs='20px'>{data?.title}</MainTitle>
        <Box gap='30px' display='flex' justifyContent='space-between' alignItems='center' sx={{ flexDirection: {xs: 'column', md: 'row'}, minHeight: '50px', width: '100%', border: '0px solid red'}}>
            <Box display='flex' sx={{maxWidth: {xs: '100%', md: '50%'}, borderRadius: '10px', border: '1px solid grey', overflow: 'clip'}}>
                <img style={{objectFit: 'cover'}} src={data?.img} alt=''/>
            </Box>
            <Box display='flex' gap='5px' sx={{maxWidth: {xs: '100%', md: '50%'} , borderRadius: '10px', flexDirection: 'column'}}>
                <>{data?.text && data?.text
                .map((row: any) => <Text>{row}</Text>)}</> 
            </Box>
        </Box>
        </Box>
    );
}

export { ImageTextBox };
